var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { Exclude, Expose } from 'class-transformer';
import { IsDateString, IsEnum, IsOptional, IsString, IsUUID } from 'class-validator';
import { PayedFeatureType } from '../payment-feature-type.enum.js';
export class PayedFeatureLiteDto {
    id;
    createdAt;
    updatedAt;
    officeLocationId;
    featureStripeId;
    entitlementStripeId;
    type;
    rawData;
}
__decorate([
    Expose(),
    IsUUID(),
    __metadata("design:type", String)
], PayedFeatureLiteDto.prototype, "id", void 0);
__decorate([
    IsDateString(),
    Expose(),
    __metadata("design:type", Date)
], PayedFeatureLiteDto.prototype, "createdAt", void 0);
__decorate([
    IsDateString(),
    Expose(),
    __metadata("design:type", Date)
], PayedFeatureLiteDto.prototype, "updatedAt", void 0);
__decorate([
    Expose(),
    IsUUID(),
    IsOptional(),
    __metadata("design:type", String)
], PayedFeatureLiteDto.prototype, "officeLocationId", void 0);
__decorate([
    Exclude(),
    IsString(),
    __metadata("design:type", String)
], PayedFeatureLiteDto.prototype, "featureStripeId", void 0);
__decorate([
    Exclude(),
    IsString(),
    __metadata("design:type", String)
], PayedFeatureLiteDto.prototype, "entitlementStripeId", void 0);
__decorate([
    IsEnum(PayedFeatureType),
    Expose(),
    IsOptional(),
    __metadata("design:type", String)
], PayedFeatureLiteDto.prototype, "type", void 0);
__decorate([
    Expose(),
    IsString(),
    __metadata("design:type", Object)
], PayedFeatureLiteDto.prototype, "rawData", void 0);
//# sourceMappingURL=payed-feature.lite.dto.js.map